import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getNewCampaignSettings } from './services/CampaignServices';
import { getCampaigns } from './services/CampaignServices';
import { formatterDataToCardInfo } from './Campaigns.helpers';
import { useSessionStorage } from 'hooks/useSessionStorage';
import Analytics from 'helpers/analytics';
import { verifyIsCompanyPermited } from 'utils/checkFunctionalityPermission';

export const columns = {
	id: { id: 'id', content: 'id', hidden: true },
	name: { id: 'name', content: 'Nombre', width: '350px' },
};

export const useCampaigns = () => {
	const { getSessionStorage } = useSessionStorage();
	const navigate = useNavigate();
	const [isModalOpen, setModalOpen] = useState<boolean>(false);
	const [isSettingsModalOpen, setSettingsModalOpen] = useState<boolean>(false);
	const [campaignSettings, setCampaignSettings] = useState<any[]>([]);
	const [isLoadingCampaigns, setLoadingCampaigns] = useState<boolean>(false);

	const [hasError, setError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [campaigns, setCampaings] = useState<any[]>([]);
	const [isCompanyCampaign, setIsCompanyCampaign] = useState<
		boolean | undefined
	>(false);
	const [showModalCampaignNotAuthorized, setShowModalCampaignNotAuthorized] =
		useState(false);

	const handleNewCampaign = async () => {
		if (!isCompanyCampaign) {
			setShowModalCampaignNotAuthorized(true);
		} else {
			fetchNewCampaign();
			setModalOpen(true);
			Analytics.track('campaign', 'open-carousel-new-campaign');
		}
	};

	const handleNewSettingsModal = () => {
		setModalOpen(false);
		setSettingsModalOpen(true);
	};

	const handleSubmitNewCampaign = (id: string) => {
		if (isCompanyCampaign) {
			navigate(`/campaigns/new/${id}`);
		} else {
			setShowModalCampaignNotAuthorized(true);
		}
	};

	const handleEditCampaign = (campaignId: any) => {
		if (isCompanyCampaign) {
			const campaign = campaigns.find((campaign) => campaign.id === campaignId);
			navigate(
				`/campaign/${campaignId}?campaignName=${window.btoa(
					campaign.companyName,
				)}`,
			);
		} else {
			setShowModalCampaignNotAuthorized(true);
		}
	};

	const fetchNewCampaign = async () => {
		setLoadingCampaigns(true);
		setModalOpen(true);
		try {
			const { data } = await getNewCampaignSettings('NOM035');
			setCampaignSettings([...data.content]);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingCampaigns(false);
		}
	};

	const fetchCampaigns = async () => {
		setIsLoading(true);
		setError(false);
		try {
			const {
				data: { content },
			} = await getCampaigns();
			const formattedDataToCardInfo = formatterDataToCardInfo(content);
			setCampaings(formattedDataToCardInfo);
		} catch (error) {
			console.error(error);
			setError(true);
		} finally {
			setIsLoading(false);
		}
	};

	const getMeInfo = async () => {
		try {
			const meCompany = getSessionStorage('me');
			if (meCompany) {
				setIsCompanyCampaign(
					verifyIsCompanyPermited(JSON.parse(meCompany).company, 'campaigns'),
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getMeInfo();
		fetchCampaigns();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isLoading,
		campaigns,
		campaignSettings,
		isModalOpen,
		isLoadingCampaigns,
		showModalCampaignNotAuthorized,
		hasError,
		isSettingsModalOpen,
		setSettingsModalOpen,
		handleNewSettingsModal,
		setShowModalCampaignNotAuthorized,
		setModalOpen,
		handleNewCampaign,
		handleEditCampaign,
		handleSubmitNewCampaign,
		onRetry: fetchCampaigns,
	};
};
